/* ============================================================
   PDP BUNDLE BUILDER  —  controller
   ------------------------------------------------------------
   Wires up the [data-sip-pack] module rendered by
   snippets/pdp-bundle-builder.liquid:

     - Resolves selected variant options to a real variant id
     - Adds to cart via /cart/add.js
     - Refreshes Rebuy SmartCart (the theme's drawer owner)
     - Polls /cart.js to keep set strip + dots + button states
       in sync with what's actually in the cart
     - Reads /cart.js on init so progress survives reloads

   Safe to load multiple times — global init guard prevents
   double-binding when the snippet renders on more than one
   product (e.g. via section editor preview).
   ============================================================ */
(function(){
  if (window.__sipPackBound) return;
  window.__sipPackBound = true;

  var ADD_URL  = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js';
  var CART_URL = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';

  function $(sel, root){ return (root || document).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Rebuy refresh ----------
     The theme uses Rebuy SmartCart for the drawer. After every
     add, fire the events Rebuy listens for + call the SDK
     directly as a belt-and-suspenders. */
  function refreshRebuy(){
    try {
      document.dispatchEvent(new CustomEvent('rebuy:cart.change',  { bubbles: true }));
      document.dispatchEvent(new CustomEvent('rebuy:cart.refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh',       { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated',       { bubbles: true }));
      if (window.Rebuy && Rebuy.SmartCart) {
        if (typeof Rebuy.SmartCart.refresh === 'function') Rebuy.SmartCart.refresh();
        if (typeof Rebuy.SmartCart.reload  === 'function') Rebuy.SmartCart.reload();
      }
    } catch(e){}
  }

  /* ---------- /cart.js fetch with simple throttle ----------
     The poller runs after every add + on a debounced cart-event
     listener. Throttle prevents stampedes when many events fire
     in a 500ms window. */
  var lastFetch = 0;
  var fetchInFlight = null;
  function fetchCart(){
    var now = Date.now();
    if (fetchInFlight) return fetchInFlight;
    if (now - lastFetch < 250) {
      return new Promise(function(resolve){ setTimeout(function(){ fetchCart().then(resolve); }, 260); });
    }
    lastFetch = now;
    fetchInFlight = fetch(CART_URL, { headers: { 'Accept':'application/json' }, credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .catch(function(){ return { items: [] }; })
      .then(function(c){ fetchInFlight = null; return c; });
    return fetchInFlight;
  }

  /* ---------- Variant resolution ----------
     Each row with options has a <script type="application/json"
     data-variant-map> child with an array of variants.
     {id, price, available, options:["Tierra","12-pack",...]}
     We read the currently-selected option values from the row's
     selects/swatches and find the matching variant. */
  function readSelectedOptions(row){
    var values = [];
    $all('[data-variant-option]', row).forEach(function(el){
      var idx = parseInt(el.getAttribute('data-variant-option'), 10);
      var v;
      if (el.tagName === 'SELECT') {
        v = el.value;
      } else {
        var sel = $('.sip-pack__swatch-btn.is-selected', el);
        v = sel ? sel.getAttribute('data-value') : null;
      }
      values[idx] = v;
    });
    return values;
  }
  function resolveVariant(row){
    var map = $('script[data-variant-map]', row);
    if (!map) {
      // No options — return the default
      return { id: parseInt(row.getAttribute('data-default-variant-id'), 10), available: true, price: parseInt(row.getAttribute('data-base-price'), 10) };
    }
    var variants;
    try { variants = JSON.parse(map.textContent); } catch(e){ variants = []; }
    var selected = readSelectedOptions(row);
    for (var i = 0; i < variants.length; i++){
      var v = variants[i];
      var match = true;
      for (var j = 0; j < selected.length; j++){
        if (selected[j] != null && v.options[j] !== selected[j]) { match = false; break; }
      }
      if (match) return v;
    }
    // Fallback to first variant
    return variants[0] || { id: parseInt(row.getAttribute('data-default-variant-id'), 10), available: true };
  }

  /* ---------- Add to cart ---------- */
  function addToCart(variantId, quantity){
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); });
  }

  /* ---------- Module instance ----------
     Each .sip-pack block on the page gets its own state. */
  function initPack(pack){
    if (pack.__sipPackInit) return;
    pack.__sipPackInit = true;

    var threshold = parseInt(pack.getAttribute('data-threshold'), 10) || 0;
    var currentProductId = pack.getAttribute('data-current-product-id') || '';
    var rows = $all('[data-row-product-id]', pack);
    var setNodes = $all('[data-set-product-id]', pack);
    var dots = $all('.sip-pack__dot', pack);
    var countEls = $all('[data-pack-count], [data-pack-count-long]', pack);

    /* Collapsed/expanded toggle. Default state is collapsed (set by
       .is-collapsed class on the snippet). Clicking the header toggles. */
    var toggleBtn = $('[data-pack-toggle]', pack);
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function(){
        var collapsed = pack.classList.toggle('is-collapsed');
        toggleBtn.setAttribute('aria-expanded', String(!collapsed));
      });
    }

    /* Per-row: update the row's variant button + price when the
       customer changes options. */
    rows.forEach(function(row){
      var btn = $('[data-pack-add]', row);
      var priceEl = $('[data-row-price]', row);

      function updateVariant(){
        var v = resolveVariant(row);
        if (v) {
          btn.setAttribute('data-variant-id', v.id);
          if (priceEl && row.getAttribute('data-is-free') !== '1' && v.price != null) {
            priceEl.textContent = formatMoney(v.price);
          }
          btn.disabled = (v.available === false);

          // Swap the row thumbnail to the variant's image (e.g. Sand hat
          // photo when "Sand" color is picked). Also swap the set-strip
          // thumbnail for this product so the visual progress matches.
          if (v.image) {
            var rowImg = row.querySelector('[data-row-img]');
            if (rowImg) rowImg.src = v.image;
            var pid = row.getAttribute('data-row-product-id');
            if (pid) {
              var setImg = pack.querySelector('[data-set-product-id="' + pid + '"] [data-set-img]');
              if (setImg) setImg.src = v.image;
            }
          }
        }
      }

      $all('select[data-variant-option]', row).forEach(function(sel){
        sel.addEventListener('change', updateVariant);
      });
      $all('.sip-pack__swatch', row).forEach(function(sw){
        $all('button', sw).forEach(function(b){
          b.addEventListener('click', function(){
            $all('button', sw).forEach(function(x){ x.classList.remove('is-selected'); });
            b.classList.add('is-selected');
            updateVariant();
          });
        });
      });

      btn.addEventListener('click', function(){
        if (btn.disabled || btn.classList.contains('is-added')) return;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding…';
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        addToCart(vid, 1)
          .then(function(){
            // Optimistic UI flip — sync() below will reconcile
            // with the actual cart in ~400ms.
            btn.classList.add('is-added');
            btn.textContent = '✓';
            btn.setAttribute('aria-label', btn.getAttribute('data-added-label') || 'Added');
            refreshRebuy();
            setTimeout(syncFromCart, 400);
          })
          .catch(function(){
            btn.textContent = originalText;
            btn.disabled = false;
          });
      });

      // Run once on init to set the variant id correctly
      updateVariant();
    });

    /* Format Shopify price cents → "$59.99". Uses the shop's
       currency format if the theme exposes it; falls back to USD. */
    function formatMoney(cents){
      if (window.Shopify && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents); } catch(e){}
      }
      return '$' + (cents / 100).toFixed(2);
    }

    /* Reconcile the UI with the real cart. Called after every
       add and after any cart event from other code on the page.
       Count uses the SET STRIP (which includes the current product)
       so adding the current product via the main page's ATC button
       still bumps the count + lights up that slot.

       Also handles the LOCK→UNLOCK transition: as soon as the current
       product is added, drop the .is-locked class AND auto-expand the
       card (one-time reveal) so the customer sees the items they can
       add to finish the pack. */
    function syncFromCart(){
      fetchCart().then(function(cart){
        var inCart = {};
        (cart.items || []).forEach(function(it){
          inCart[String(it.product_id)] = true;
        });

        // Locked state — toggle based on whether the current product is in cart
        var wasLocked = pack.classList.contains('is-locked');
        var isLockedNow = currentProductId && !inCart[currentProductId];
        pack.classList.toggle('is-locked', !!isLockedNow);
        // One-time auto-expand on the lock→unlock transition
        if (wasLocked && !isLockedNow && pack.classList.contains('is-collapsed')) {
          pack.classList.remove('is-collapsed');
          if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
        }

        // Update each row's Add button (these are the OTHER pack items —
        // the current product is intentionally not rendered as a row)
        rows.forEach(function(row){
          var pid = row.getAttribute('data-row-product-id');
          var btn = $('[data-pack-add]', row);
          var hasIt = !!inCart[pid];
          if (btn) {
            var addedLabel = btn.getAttribute('data-added-label') || 'Added';
            var addLabel = btn.getAttribute('data-add-label') || 'Add';
            if (hasIt) {
              btn.classList.add('is-added');
              // Compact "added" state — just a check so it doesn't crowd
              // the row when there are color swatches / long titles.
              // Full label moves to aria-label for screen readers.
              btn.textContent = '✓';
              btn.setAttribute('aria-label', addedLabel);
              btn.disabled = false;
            } else if (btn.classList.contains('is-added')) {
              btn.classList.remove('is-added');
              btn.textContent = addLabel;
              btn.removeAttribute('aria-label');
              btn.disabled = false;
            }
          }
        });

        // Set strip — covers ALL pack items including current product
        var count = 0;
        setNodes.forEach(function(sc){
          var pid = sc.getAttribute('data-set-product-id');
          var hasIt = !!inCart[pid];
          sc.classList.toggle('is-on', hasIt);
          if (hasIt) count++;
        });

        // Dots
        dots.forEach(function(d, i){ d.classList.toggle('is-on', i < count); });

        // Count labels + completion
        countEls.forEach(function(el){ el.textContent = count; });
        pack.classList.toggle('is-complete', count >= threshold);
      });
    }

    // Initial sync — reflects current cart (e.g. user already
    // added stuff before landing on this PDP, or page reloaded)
    syncFromCart();

    // Listen for cart events triggered elsewhere on the page
    // (Rebuy refresh, native cart updates, other modules) so
    // the pack card stays accurate without manual reload.
    ['cart:added','cart:refresh','cart:updated','cart:change',
     'rebuy:cart.change','rebuy:cart.refresh'].forEach(function(evt){
      document.addEventListener(evt, function(){ setTimeout(syncFromCart, 500); });
    });
  }

  /* ---------- Boot ---------- */
  function boot(){
    $all('[data-sip-pack]').forEach(initPack);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Shopify theme-editor support — re-init when this section reloads
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();